import { IFile } from 'src/app/interfaces/io/file.interface';
import { ILaunchSettings } from 'src/app/interfaces/io/launch-settings.interface';
import { ILauncher } from './launcher.interface';

export class VoidLauncher implements ILauncher {
  launch(_file?: IFile, _content?: string, settings?: ILaunchSettings): Promise<any> {
    alert("No suitable launcher found for the file type.");
    return Promise.resolve(1);
  }
}
